import { useContext, useEffect, useState } from "react";
import { Avatar, CallIcon, Card, CardBody, CardHeader, EmailIcon, Flex, Loader, LocationIcon, Text } from "@fluentui/react-northstar";
import "./ContactInformation.css";
import { TeamsFxContext } from "./Context";
import * as microsoftTeams from "@microsoft/teams-js";

export default function ContactInformation() {


    return (
        <>
            <div className="contact-information">
                <div className="contact-information-header">
                    <Avatar size="larger" image="/profilepicture-contact.png" />
                    <div className="contact-information-header-name">Sil Steffens</div>
                </div>
                
                <div className="row-container client">
                    <h3>Client</h3>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">Sil Steffens</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><LocationIcon disabled /></div>
                        <div className="row-value">Hazenkoog 25</div>
                    </div>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">1822 BS Alkmaar</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><CallIcon disabled /></div>
                        <div className="row-value">0612345678</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><EmailIcon disabled /></div>
                        <div className="row-value">sil.steffens@cybertwice.com</div>
                    </div>
                </div>

                <div className="row-container doctor">
                    <h3>Doctor</h3>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">Huisartsenpraktijk</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><LocationIcon disabled /></div>
                        <div className="row-value">Geert Groteplein 28a</div>
                    </div>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">1813 BM Alkmaar</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><CallIcon disabled /></div>
                        <div className="row-value">072–5113193</div>
                    </div>
                </div>

                <div className="row-container caregiver1">
                    <h3>Caregiver 1</h3>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">Maarten Steffens</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><LocationIcon disabled /></div>
                        <div className="row-value">Flemingstraat 50</div>
                    </div>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">1704 SL Heerhugowaard</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><CallIcon disabled /></div>
                        <div className="row-value">0687654321</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><EmailIcon disabled /></div>
                        <div className="row-value">maarten.steffens@cybertwice.com</div>
                    </div>
                </div>

                <div className="row-container caregiver2">
                    <h3>Caregiver 2</h3>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">Wouter Steffens</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><LocationIcon disabled /></div>
                        <div className="row-value">Tulpstraat 106</div>
                    </div>
                    <div className="row">
                        <div className="row-name"></div>
                        <div className="row-value">1645 VR 1 Ursem</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><CallIcon disabled /></div>
                        <div className="row-value">0633331111</div>
                    </div>
                    <div className="row">
                        <div className="row-name"><EmailIcon disabled /></div>
                        <div className="row-value">wouter.steffens@cybertwice.com</div>
                    </div>
                </div>

            </div>
        </>
    );
}
